import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { formatUrl } from '@/utils/url';
import { CountriesEnum } from '@/enums/countries';
import { getTranslatableSlug } from '@/utils/translatable-slug';

export const getLinkPath = (link, includeDomain = false) => {
	const externalLink = link.linktype === 'url';
	const linkWithAnchor = link.anchor ? `${link.cached_url}#${link.anchor}` : link.cached_url;
	let linkPath = link.linktype === 'url' ? link.url : linkWithAnchor;

	if (link.story) {
		const linkLang = link.story.lang;
		const translatedSlug = getTranslatableSlug(link.story, linkLang);

		if (translatedSlug) {
			linkPath = `${linkLang}/${translatedSlug.path}`;
		}
	}

	if (externalLink) {
		const { i18n } = useTranslation();

		const country = CountriesEnum.find(c => c.locale === i18n.language);
		const locale = country?.locale || 'en';
		const language = country?.language || 'en';

		return linkPath.replace('{locale}', locale).replace('{language}', language);
	}

	return formatUrl(linkPath, includeDomain);
};

function LinkComponent({ link, appearance, openNewTab, children, additionalProps = {} }) {
	const target = openNewTab ? '_blank' : '_self';
	const externalLink = link.linktype === 'url';
	let linkPath = getLinkPath(link);

	// Use relative path for gynzy.com links
	if (linkPath.startsWith('https://www.gynzy.com/')) {
		linkPath = linkPath.replace('https://www.gynzy.com/', '/');
	}

	if (externalLink) {
		return (
			<a href={linkPath} className={appearance} target={target} rel="nofollow" {...additionalProps}>
				{children}
			</a>
		);
	}

	return (
		<Link to={linkPath} className={appearance} target={target} {...additionalProps}>
			{children}
		</Link>
	);
}

export default LinkComponent;
